import { useState } from "react";

export function usePager<T>(items: T[], pageSize: number) {
  const [pages, setPages] = useState(1);
  const shown = Math.min(items.length, pages * pageSize);
  return {
    visible: items.slice(0, shown),
    total: items.length,
    shown,
    hasMore: shown < items.length,
    canCollapse: pages > 1,
    showMore: () => setPages((value) => value + 1),
    showAll: () => setPages(Math.ceil(items.length / pageSize) || 1),
    collapse: () => setPages(1),
  };
}
